import {
  globalAxios,
  backendVersion,
  managerInstance,
  merchantInstance,
  axiosPath,
} from "@/axios-path.js";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    cashListData: [],
    fetchCountRequest: "",
    getDetailCash: {
      bank_weserve: { bank_weserve_bank: {} }, bank_manager: { bank_manager_bank: {} }
    },
  },
  mutations: {
    getCashlistData(state, data) {
      state.cashListData = data;
    },
    fetchCountRequest(state, data) {
      state.fetchCountRequest = data;
    },
    getDetailCash(state, data) {
      state.getDetailCash = data;
    },
  },
  actions: {
    async fetchcashList({ commit }, item) {
            let url = `${backendVersion.version
                }/partner/get_list_request_cash?status=${item}`;
            return managerInstance
                .get(url)
                .then((res) => {
                    commit("getCashlistData", res.data);
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
    async fetchCountRequest({ commit }, config) {
      let url = backendVersion.version + "/partner/get_count_request_cash";
      return managerInstance
        .get(url, { params: config })
        .then((res) => {
          if (res.msg == false) return false;
          commit("fetchCountRequest", res.data);
          return res.data;
        })
        .catch((err) => {
          return [];
        });
    },
    async getDetailCash({ commit }, item) {
      let url = `${
        backendVersion.version
      }/partner/get_detail_request_cash/${item}`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("getDetailCash", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async ApproveBankManager({ commit }, id) {
      const payload = {
        transaction_partner_id: id,
      };
      let url = `${backendVersion.version}/partner/approve_request_cash`;
      return managerInstance
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },

    async RejectBankManager({ commit, dispatch }, { payload }) {
      let url = backendVersion.version + "/partner/approve_request_cash";
      const remark = {
        transaction_partner_id : payload.transaction_partner_id,
        remark : payload.remark,
      };
      return managerInstance
        .delete(url, {
          data: remark,
        })
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
  },
  getters: {},
};
